import type { CompositionMode, CompositionItemProjectionMeta } from '../types';

export type CompositionRowSource = 'RECOMMENDED' | 'AUTO' | 'MANUAL';

export type CompositionRowSourceInput = {
  compositionMode: CompositionMode;
  isManual: boolean;
  compositionItemId: number | null;
  compositionMeta?: CompositionItemProjectionMeta | null;
};

const SOURCE_LABELS: Record<CompositionRowSource, string> = {
  RECOMMENDED: 'Рекомендуемый',
  AUTO: 'Авто',
  MANUAL: 'Добавлен вручную',
};

/**
 * Display-only source badge — FE-005A Technical Plan §3.3.
 * Uses existing row / projection fields only.
 */
export function resolveCompositionRowSource(input: CompositionRowSourceInput): CompositionRowSource {
  if (input.isManual) {
    return 'MANUAL';
  }

  if (
    input.compositionMode === 'RECOMMENDED' &&
    input.compositionItemId == null &&
    input.compositionMeta == null
  ) {
    return 'RECOMMENDED';
  }

  return 'AUTO';
}

export function compositionRowSourceLabel(source: CompositionRowSource): string {
  return SOURCE_LABELS[source];
}

export type CompositionRowBadge = {
  key: string;
  label: string;
};

/** Resolves document-column badges from row model — no UI logic in components. */
export function resolveCompositionRowBadges(input: {
  source: CompositionRowSource;
  required: boolean;
  compositionStatus: 'INCLUDED' | 'EXCLUDED';
}): CompositionRowBadge[] {
  const badges: CompositionRowBadge[] = [];

  if (input.source === 'RECOMMENDED') {
    badges.push({ key: 'source-recommended', label: SOURCE_LABELS.RECOMMENDED });
  } else if (input.source === 'AUTO') {
    badges.push({ key: 'source-auto', label: SOURCE_LABELS.AUTO });
  }

  if (input.source === 'MANUAL') {
    badges.push({ key: 'manual', label: SOURCE_LABELS.MANUAL });
  }

  if (input.compositionStatus === 'EXCLUDED') {
    badges.push({ key: 'excluded', label: 'Исключён' });
  }

  return badges;
}
